import { useCallback, useState } from 'react';
import api from '../services/api';

/**
 * Confirma o convite de acesso e ativa a conta com a senha escolhida.
 *
 * Usado por `ConfirmInvitePage` — a criação da conta que gera este convite
 * hoje vem do provisionamento SaaS (checkout público / cadastro manual de
 * creche), não de uma tela de gestão de usuários por tenant.
 */
export function useConfirmInvite() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const confirmInvite = useCallback(
    async (token: string, senha: string, consentimento_lgpd: boolean) => {
      if (!token || senha.length < 12 || !consentimento_lgpd) {
        throw new Error('Token, senha (min 12 chars) e consentimento LGPD são obrigatórios');
      }

      setLoading(true);
      setError(null);
      try {
        const { data } = await api.post('/users/confirm-invite', {
          token,
          senha,
          consentimento_lgpd,
        });
        return data;
      } catch (err: any) {
        const message = err.response?.data?.message || 'Erro ao confirmar convite';
        setError(message);
        throw new Error(message);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { confirmInvite, loading, error };
}
